import '@vfde-brix/image-gallery/dist/styles.css';
import { createImageGalleryComponent } from '@vfde-brix/image-gallery';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-image-gallery-slider', createImageGalleryComponent, NO_PATTERN_BUSINESS_LOGIC);
